import { createReducer } from "redux-act";
import {
    validateCropListToggle,
    unlinkedCropsToggle,
    unlinkedProductsToggle,
    validateEquationToggle,
    testEquationSuccess,
    testEquationFailed,
    setEquationParametersPicklist,
} from "./actions";

export const EQUATION_LIST_DATA_KEY = "EQUATION_LIST_DATA";

export const equationListReducer = createReducer(
    {
        [validateCropListToggle]: (state, payload = false) => ({
            ...state,
            validCropList: payload,
        }),
        [unlinkedCropsToggle]: (state, payload = false) => ({
            ...state,
            hasUnlinkedCrop: payload,
        }),
        [unlinkedProductsToggle]: (state, payload = false) => ({
            ...state,
            hasUnlinkedProduct: payload,
        }),
        [validateEquationToggle]: (state, payload = false) => ({
            ...state,
            validEquation: payload,
        }),
        [testEquationSuccess]: (state, payload) => ({
            ...state,
            testValue: payload,
        }),
        [testEquationFailed]: (state) => ({
            ...state,
            testValue: "",
        }),
        [setEquationParametersPicklist]: (state, payload) => ({
            ...state,
            equationParametersPicklist: payload,
        }),
    },
    {
        testValue: "",
        validCropList: false,
        hasUnlinkedCrop: false,
        hasUnlinkedProduct: false,
        validEquation: {},
        equationParametersPicklist: new Map(),
    }
);
